import {
  UPDATE_COMPANY_SEARCH_TERM,
  SHOW_LOADING_INDICATOR,
  FETCHED_COMPANY_SUGGESTIONS,
  SELECT_COMPANY,
  ERROR_FETCHING_SUGGESTIONS,
  SET_OTHER_ASSOCIATED_ACCOUNT,
  NO_MATCHING_COMPANIES,
} from '../constants';

const INITIAL_STATE = {
  selectedCompany: null,
  fetchingSuggestions: false,
  suggestions: [],
  companySearchTerm: '',
  otherAssociatedAccount: null,
  noMatchingCompanies: false,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case UPDATE_COMPANY_SEARCH_TERM:
      return { ...state, companySearchTerm: payload, noMatchingCompanies: false };
    case SELECT_COMPANY:
      return { ...state, selectedCompany: payload };
    case SET_OTHER_ASSOCIATED_ACCOUNT:
      return { ...state, otherAssociatedAccount: payload };
    case SHOW_LOADING_INDICATOR:
      return { ...state, fetchingSuggestions: true };
    case FETCHED_COMPANY_SUGGESTIONS:
      return {
        ...state, suggestions: payload, fetchingSuggestions: false, noMatchingCompanies: false,
      };
    case ERROR_FETCHING_SUGGESTIONS:
      return {
        ...state, suggestions: [], fetchingSuggestions: false, noMatchingCompanies: false,
      };
    case NO_MATCHING_COMPANIES:
      return {
        ...state, suggestions: [], fetchingSuggestions: false, noMatchingCompanies: true,
      };
    default:
      return state;
  }
};
